import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Upload, Input, Button, Spin, Pagination, Modal } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import user from '../../Actions/user';
import certificates from '../../Actions/certificates';
import Delete from '../delete';
import TableView from '../tableView';
import IssuingVolumeMonthly from './IssuingVolumeMonthly';
import { pageGA } from '../../Helpers/GoogleAnalytics';
import { isUndefinedOrNull } from "../../Helpers/validationsHelper";
const { saveCertificates, setCertificatesData, updateCertificatesPagination, deleteCertificate } = certificates.actions;
const { getUserData } = user.actions;

class Certifieds extends Component {
	constructor(props) {
		super(props);
		this.setCertificatesData = this.setCertificatesData.bind(this);
		this.actions = this.actions.bind(this);
		this.showModalDeleteCertificate = this.showModalDeleteCertificate.bind(this);
		this.deleteCertificate = this.deleteCertificate.bind(this);
		this.state = {
			deleteCertificateModalVisible: false,
			taxIdSelected: ''
		}
	}
 
	componentDidMount(){
		let queryCertificates = {
			...this.props.certificatesPagination,
			perPage:10
		}
		this.props.getUserData(queryCertificates);
		pageGA();
	}

  	render() {  
		let { fileList, password } = this.props.certifieds;
		let { page, perPage, totalCount } = this.props.certificatesPagination;
		const props = {
			beforeUpload: file => {        	
					const ext = file.name.substring(file.name.lastIndexOf(".") + 1);
					if(ext === 'cer')
						fileList[0] = file;
					else
						fileList[1] = file;
					this.setCertificatesData({...this.props.certifieds, fileList});
					return false;
				}
    	};
    
    	return (			
      		<Fragment>      			
        		<p className="label"> Es necesario cargar tu FIEL para el funcionamiento adecuado de tu herramienta. Estos datos serán resguardados y encriptados en nuestra bóveda segura de este sistema ¡por lo que no tendrás que preocuparte por la seguridad de tu información!</p>
        		<div className="settings-form">
					<div className="upload-inputs-wrapper">
						<label className="label">FIEL (.key):</label>
						<Input placeholder="" style={{width:'260px'}} value={fileList[1]  ? fileList[1].name : ''} disabled={true}/>
						<Upload {...props} accept=".key">            
							<Button>            
								<UploadOutlined /> Cargar Archivo KEY
							</Button>
						</Upload>
					</div>
					<div className="upload-inputs-wrapper">
						<label className="label">FIEL (.cer):</label>
						<Input placeholder="" style={{width:'260px'}} value={fileList[0] ? fileList[0].name : ''} disabled={true}/>
						<Upload {...props} accept=".cer">            
							<Button>            
								<UploadOutlined /> Cargar Archivo CER
							</Button>
						</Upload>
					</div>        		
					<div className="upload-inputs-wrapper">
						<label className="label">Contraseña</label>
						<Input type='password' placeholder="" style={{width:'260px'}} value={password} onChange={this.setPasswordValue.bind(this)}/>
					</div>
					<div className="upload-inputs-wrapper" style={{justifyContent:'center'}}>
						<Button style={{display:'flex'}} type="primary" onClick={this.handleUpload}>            
							Guardar
						</Button>
					</div>
				</div>
				<div className="line"></div>
				<h1 className="regular-text">Mis certificados</h1>
          		<TableView loading={this.props.userLoading } columns={this.actions()} data={this.props.userData} />
					<Pagination
						total={totalCount}
						showTotal={total => `Total ${total}  registros`}
						pageSize={perPage}
						defaultCurrent={1}
						current={page}
						showSizeChanger={false}
						onChange={this.updateRecords.bind(this)}
					/>
				{ ( this.props.certificatesLoading) &&
					<div className="loading-container">
						<Spin size="large" tip="Cargando" />
					</div>
				}
				<Modal
					title="Aviso"
					visible={this.state.deleteCertificateModalVisible}
					onOk={this.deleteCertificate}
					onCancel={() => { this.setState({deleteCertificateModalVisible:false})}}
					okText="Eliminar"
					cancelText="Cancelar"
				>
					<p>¿Deseas eliminar el certificado <em className="em">{ this.state.taxIdSelected}</em>?</p>
					<p>Recuerda que esta operación es permanente</p>
        		</Modal>
            </Fragment>
    	);
	}

	updateRecords(page, pageSize) {    
		let query = {
		  ...this.props.certificatesPagination,
		  page
		}
		this.props.updateCertificatesPagination(query);
		this.props.getUserData(query);
  
	}

	handleUpload = () => {
		this.props.saveCertificates(this.props.certifieds);			
	};

	setPasswordValue(e){
		this.setCertificatesData({ ...this.props.certifieds, password: e.target.value});
	}

	setCertificatesData(data){		
		this.props.setCertificatesData(data);
	}

	resetFields(){
		this.setState({fileList:[],password:''})
	}

	showModalDeleteCertificate(data) {  
		this.setState({deleteCertificateModalVisible:true,taxIdSelected: data.taxId});		
	}

	deleteCertificate() {
		this.props.deleteCertificate(this.state.taxIdSelected,this.props.certificatesPagination);
		this.setState({deleteCertificateModalVisible:false});
	}

	actions() {
		const columns = [
			{
				title: 'Nombre',
				dataIndex: 'name',
				key: 'name'      
			},
			{
				title: 'RFC',
				dataIndex: 'taxId',
				key: 'taxId',
			},
			{
				title: 'Desde',
				dataIndex: 'notBefore',
				key: 'notBefore',
			},
			{
				title: 'Hasta',
				dataIndex: 'notAfter',
				key: 'notAfter',
			},
			{
				title: 'Estimado mensual emisión',
				key: 'issuingVolumeMonthly',
				render: (text, row) => getMonthlyVolume(row, 'issuingVolumeMonthly')
			},
			{
				title: 'Estimado mensual recepción',
				key: 'receivingVolumeMonthly',
				render: (text, row) => getMonthlyVolume(row, 'receivingVolumeMonthly')
			},
			{
				title: 'Estimado mensual',
				key: 'estimateMonthlyVolumen',
				render: (text, row) => (
					<IssuingVolumeMonthly data={row} query={this.props.certificatesPagination}/>
				)
			},
			{
				title: '',
				key: 'action',
				render: (text, row) => (
					<Delete action={this.showModalDeleteCertificate} data={row}/>
				)
			}
		];
		return columns;
	}
}

const getMonthlyVolume = (row, key) => {
	const item = row[key];
	if(isUndefinedOrNull(item) || (item === 0 && row.createdDate === row.updatedDate)) {
		return <span>-</span>;
	}
	return <span>{item} XML</span>;
}

const mapStateToProps = state => {	
	let certificatesLoader =  state._genericComponents.loading.find('loadingCertificates');	
	let userLoader =  state._genericComponents.loading.find('userLoading');
	return {
		userData: state.user.userData,
		certificatesLoading: certificatesLoader ? certificatesLoader.isLoading : false,
		userLoading: userLoader ? userLoader.isLoading : false,
		certifieds: state.certificates.certifieds,
		certificatesPagination: state.certificates.certificatesPagination
	};
};

const mapDispatchToProps = dispatch => {
    return {
    	saveCertificates(data){            
            dispatch(saveCertificates(data));
        },
        getUserData(query){
        	dispatch(getUserData(query))
		},
		setCertificatesData(data ){
			dispatch(setCertificatesData(data))
		},
		updateCertificatesPagination(query) {
			dispatch(updateCertificatesPagination(query))
		},
		deleteCertificate(taxId, query) {
			dispatch(deleteCertificate(taxId,query))
		}
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Certifieds);
